import React, { Children } from 'react';
import { Grid } from '@mui/material';
import PropTypes from 'prop-types';

export default function SendOfferGrid({ children }) {
  const items = Children.toArray(children);

  return (
    <Grid container spacing={0}>
      <Grid size={12}>{items[0]}</Grid>
      <Grid size={12}>{items[1]}</Grid>
      <Grid size={12}>{items[2]}</Grid>
      <Grid size={12}>{items[3]}</Grid>
      <Grid container size={12} spacing={2}>
        <Grid container size={6} spacing={0}>
          {items[4]}
        </Grid>
        <Grid container size={6} spacing={0}>
          {items[5]}
        </Grid>
      </Grid>
      <Grid size={12}>{items[6]}</Grid>
      <Grid size={12}>{items[7]}</Grid>
      <Grid size={12}>{items[8]}</Grid>
      <Grid size={12}>{items[9]}</Grid>
      <Grid size={12}>{items[10]}</Grid>
      <Grid size={12}>{items[11]}</Grid>
      <Grid size={12}>{items[12]}</Grid>
      <Grid size={12}>{items[13]}</Grid>
      <Grid size={12}>{items[14]}</Grid>
      <Grid size={12}>{items[15]}</Grid>
    </Grid>
  );
}

SendOfferGrid.propTypes = {
  children: PropTypes.node,
};
